"use client";

import { Play } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface VideoItem {
  id: number;
  title: string;
  poster: string;
  videoUrl: string;
}
export default function VideoGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const videos: VideoItem[] = [{
    id: 1,
    title: "Instagram Reel - Prodotto Vino",
    poster: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-04-at-16.31.14.png",
    videoUrl: "https://www.instagram.com/p/DT-kkOiiLg4/"
  }, {
    id: 2,
    title: "Video di presentazione",
    poster: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-04-at-16.30.26.png",
    videoUrl: "https://www.instagram.com/p/DUVwYcDiIFn/"
  }, {
    id: 3,
    title: "Instagram Reel - Ristosubito",
    poster: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-04-at-16.31.08.png",
    videoUrl: "https://www.instagram.com/p/DTfjVdPCIzd/"
  }, {
    id: 4,
    title: "Instagram Reel - Prodotto Frigo",
    poster: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-04-at-16.31.58.png",
    videoUrl: "https://www.instagram.com/p/DRy7V9UCG6r/"
  }, {
    id: 5,
    title: "Coming soon...",
    poster: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-09-at-08.55.56.png?v=oobtqmgzm7",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
  }, {
    id: 6,
    title: "Coming soon...",
    poster: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-09-at-08.55.56.png?v=oobtqmgzm7",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
  }, {
    id: 7,
    title: "Coming soon...",
    poster: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-09-at-08.55.56.png?v=oobtqmgzm7",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
  }, {
    id: 8,
    title: "Coming soon...",
    poster: "https://promarketing.club/wp-content/uploads/2026/02/Screenshot-2026-02-09-at-08.55.56.png?v=oobtqmgzm7",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
  }];
  return <section className="bg-light-background py-16 px-6 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground-light lg:text-5xl">
            Portfolio Video
          </h2>
          <p className="text-muted-foreground mt-4 text-lg">
            Scopri i nostri progetti social più recenti per brand innovativi
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {videos.map((video, i) => <Link key={video.id} to={video.videoUrl} newTab data-index={i} className={`group relative block overflow-hidden rounded-lg shadow-soft transition-all duration-200 ease-[var(--ease-out-back)] hover:scale-105 hover:shadow-medium hover:-translate-y-1 ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
          animationDelay: `${i * 50}ms`
        }}>
              <div className="relative aspect-[9/16] bg-muted">
                <img src={video.poster} alt={video.title} className="h-full w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-110 group-hover:shadow-[0_0_24px_rgba(255,138,0,0.6)]">
                    <Play className="h-8 w-8 translate-x-0.5 text-foreground animate-[pulse_800ms_ease-in-out_infinite]" />
                  </div>
                </div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-4">
                <h3 className="font-display text-sm font-semibold text-white">
                  {video.title}
                </h3>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}